/**
 * @file order-info-row.tsx
 * @module app/modules/orders-delivery/components/order-details/order-info-row
 * @description One label and value pair in the order details and edit order details cards.
 * Render it inside a `<dl className="od-info-list">` so the labels line up in one column.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.2
 * @version 2.1.2
 */

import { ReactNode } from "react";

interface OrderInfoRowProps {
  label: ReactNode;
  children: ReactNode;
}

const OrderInfoRow = ({ label, children }: OrderInfoRowProps) => (
  <>
    <dt className="od-info-list__label">{label}</dt>
    <dd className="od-info-list__value">{children}</dd>
  </>
);

export default OrderInfoRow;
